module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_13.173ad734.jpg";